import React from "react";
import Nav from "../../components/nav";
import NoticeBanner from "../../components/notice-banner";
import Footer from "../../components/footer";

const V2Layout = ({
  children,
  currUser,
  isAuthenticated,
  handleLogout,
  noticeBanner,
  classes,
  bannerTopMobile = 53,
  ...props
}) => {
  // Calculate dynamic content padding based on banner position
  const getContentPadding = () => {
    const isDesktop = window.innerWidth >= 960;
    const headerHeight = isDesktop ? 0 : 120;
    
    return {
      paddingTop: headerHeight,
    };
  };
  const bannerEnabled = noticeBanner && noticeBanner.enabled;
  const contentWrapperStyles = bannerEnabled ? getContentPadding() : {};

  return (
    <React.Fragment>
      <Nav
        isAuthenticated={isAuthenticated}
        currUser={currUser}
        handleLogout={handleLogout}
        {...props}
      />
      <NoticeBanner
        message={noticeBanner && noticeBanner.message}
        messageFr={noticeBanner && noticeBanner.messageFr}
        visible={noticeBanner && noticeBanner.enabled}
        topMobile={bannerTopMobile}
      />
      <div style={contentWrapperStyles}>
        {children}
      </div>
      <Footer />
    </React.Fragment>
  );
};

export default V2Layout;
